
import Cookies from 'js-cookie'

const FocusNoticeKey = 'Focus_Notice'
const RegCodeKey = 'REG_CODE'
const WxCodeKey = 'WX_CODE'
const FirstKey = 'First'
const SurveyCodeKey = 'Survey_CODE'
const SearchHistoryKey = 'SH'
const SearchVipUserHistoryKey = 'SVUH'
const SearchVipEpHistoryKey = 'SVEH'
const ExhibitorMidKey = 'Exhibitor_Mid'

const RegSourceKey = 'ref'

export function delFirstPage() {
return Cookies.remove(FirstKey)
}

export function getFocusNotice() {
return Cookies.get(FocusNoticeKey)
}

export function setFocusNotice() {
return Cookies.set(FocusNoticeKey, 1, {
expires: 7
})
}

export function getRegCode() {
return Cookies.get(RegCodeKey)
}

export function setRegCode(code) {
return Cookies.set(RegCodeKey, code, {
expires: 0.0035
})
}

export function delRegCode() {
return Cookies.remove(RegCodeKey)
}

export function getWxCode() {
return Cookies.get(WxCodeKey)
}

export function setWxCode(code) {
return Cookies.set(WxCodeKey, code, {
expires: 0.0035
})
}

export function delWxCode() {
return Cookies.remove(WxCodeKey)
}

export function getSurveyCode() {
return Cookies.get(SurveyCodeKey)
}

export function setSurveyCode(code) {
return Cookies.set(SurveyCodeKey, code)
}

export function getExhibitorMid() {
return Cookies.get(ExhibitorMidKey)
}

export function setExhibitorMid(code) {
return Cookies.set(ExhibitorMidKey, code)
}

export function delSurveyCode() {
return Cookies.remove(SurveyCodeKey)
}

export function getSearchHistory() {
return Cookies.get(SearchHistoryKey)
}

export function setSearchHistory(content) {
return Cookies.set(SearchHistoryKey, content)
}

export function removeSearchHistory() {
return Cookies.remove(SearchHistoryKey)
}

export function getVipUserSearchHistory() {
return Cookies.get(SearchVipUserHistoryKey)
}

export function setVipUserSearchHistory(content) {
return Cookies.set(SearchVipUserHistoryKey, content)
}

export function removeVipUserSearchHistory() {
return Cookies.remove(SearchVipUserHistoryKey)
}

export function getVipEpSearchHistory() {
return Cookies.get(SearchVipEpHistoryKey)
}

export function setVipEpSearchHistory(content) {
return Cookies.set(SearchVipEpHistoryKey, content)
}

export function removeVipEpSearchHistory() {
return Cookies.remove(SearchVipEpHistoryKey)
}

export function setRegSource(source) {
return Cookies.set(RegSourceKey, source)
}

export function getRegSource() {
return Cookies.get(RegSourceKey)
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js